import { colors } from '@material-ui/core';
import { softShadows } from './shadows';

export default {
  responsiveFontSizes: true,
  overrides: {
    MuiInputBase: {
      input: {
        '&::placeholder': {
          opacity: 1,
          color: colors.blueGrey[600]
        }
      }
    }
  },
  palette: {
    type: 'light',
    action: {
      active: colors.blueGrey[600]
    },
    background: {
      default: colors.common.white,
      dark: '#f4f6f8',
      paper: colors.common.white
    },
    primary: {
      // main: colors.indigo[600]
      // main: '#222'
      // main: '#673ab7'
      main: '#333'
    },
    secondary: {
      // main: '#5850EC'
      // main: '#ff4081'
      main: '#f5b461'
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600]
    }
  },
  shadows: softShadows
};
